import React, { useEffect, useState } from "react";
import { Redirect, Route, useHistory, useLocation, Switch } from "react-router";
import { useDispatch } from "react-redux";
import {
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  isPlatform,
} from "@ionic/react";
import { IRoute } from "./sidebar.schema";
import { useAuthService } from "../../../services/Auth";
import { setManageSegmentSelected } from "../../../actions/manage/action";
import { setNavigation } from "../../../actions/App/action";
import { SearchContainer } from "../../../web/containers/SearchContainer";
import DashoardContainer from "../../../web/containers/DashoardContainer/DashoardContainer";
import { MyLoadsContainer } from "../../../web/containers/MyLoadsContainer";
import { RecentlyDeliverdContainer } from "../../../web/containers/RecentlyDeliverdContainer";
import { CarrierAssignedContainer } from "../../../web/containers/CarrierAssignedContainer";
import { DriverAssignedContainer } from "../../../web/containers/DriverAssignedContainer";
import { InTransitContainer } from "../../../web/containers/InTransitContainer";
import { SearchResultContainer } from "../../../web/containers/SearchContainer/SavedSearchcontainer/SearchResultContainer";
import ProfileContainer from "../../../web/containers/ProfileContainer/ProfileContainer";
import ExecutionContainer from "../../../web/containers/ExecutionContainer/ExecutionContainer";
import ExecutionDetailsContainer from "../../../web/containers/ExecutionContainer/ExecutionDetailsContainer";
import { ManageUserContainer } from "../../containers/ManageUsersContainer/index";
import { ManageProfileContainer } from "../../containers/ManageUsersContainer/index";
import {
  ManageCapacityAddContainer,
  ManageCapacityContainer,
  ManageCapacityEditContainer,
  ManageCapacityViewContainer,
  ManageCapacitySeeResultContainer,
} from "../../containers/ManageCapacityContainer";
import SupportContainer from "../../../web/containers/SupportContainer/SupportContainer";
import { FeedbackContainer } from "../../containers/FeedbackContainer/index";
import { PreferencesContainer } from "../../containers/PreferencesContainer/index";
import { CarrierProfileContainer } from "../../../web/containers/CarrierProfileContainer";
import NotificationContainer from "../../../web/containers/NotificationsContainer/NotificationContainer";
import { CarrierTenderedContainer } from "../../../web/containers/CarrierTenderedContainer";
import { DeliveredWithPPWKContainer } from "../../../web/containers/MyLoadsContainer/DeliveredWithPPWKContainer";
import { ToastMessage } from "../../../utils/ToastMessage";
import {
  FEEDBACK,
  PREFERENCES,
  MORE,
  MY_LOAD,
  REGISTER_TO_GET_FULL_ACCESS,
  HOME,
  CARRIER_ASSIGNED_MODULE_WEB,
  COMPATIBILE_WIDTH,
  RESOLUTION_INCOMPATIBLE_MESSAGE,
  DRIVER_ASSIGNED_MODULE_WEB,
  INTRANSIT_MODULE_WEB,
  DELIVERED_NEEDS_PPWK_MODULE_WEB,
  DELIVERED_WITH_PPWK_MODULE_WEB,
  USER_ROLES,
  FUEL_SAVING,
  TRAILER_LEASE_MODAL,
  CARRIER_TENDERED_MODULE_WEB,
  isMyload,
} from "../../../utils/constants";
import { IONICWrapper, isEntitled } from "../../../utils/common";
import { isEmptyObject } from "../../utils/BasicLogical.Util";
import { isDispatcherRole } from "../../../utils/roleUtil/RoleUtil";
import BackToTop from "../../../utils/backToTop/BackToTop";
import { logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { EBehaviour } from "../../../utils/backToTop/BackToTop.type";
import { noAccessUrl, sideBarTabs} from "./sidebar.util";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { Notification } from "../notification";
import "./sidebar.scss";

const Sidebar = (props: any) => {
  const dispatch = useDispatch();
  const history:any = useHistory();
  const location = useLocation();
  const { contentStackData } = props;
  const [showNotification, SetShowNotification] = useState(false);
  const [contentStackobj, setContentStackObj] = useState({});
  const [sidebarNav, setTileNavigation] = useState<any>(props.navigation);
  const [selectedTab, onSelectTab] = useState<string>("");
  const [selectedMoreTab, onSelectMoreTab] = useState<string>("");
  const navString: string = JSON.stringify(props.navigation);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [sidebarRoutes,setSidebarRoutes] = useState<IRoute[]>(sideBarTabs(isDispatcherRole()));
  const [modalProps, setModalProps] = useState<any>({isModalOpen:false});
  const [subcategoryProps, setSubcategoryProps] = useState<any>({isModalOpen:false});
  const [openMoreModal , setOpenMoreModal] = useState<boolean>(false);

  useEffect(() =>{
    const {carrierTenderedCount, carrierAssignedCount, ...driverMyLoadCount} = props.myLoadCount;
    let isMyLoadCountUpdated = !!Object.values(isDispatcherRole()?props.myLoadCount:driverMyLoadCount).find((item : any) =>item != 0);
    if (isEmptyObject(props.navigation) && selectedTab === MY_LOAD && isMyLoadCountUpdated && !(history.location?.state?.shipmentId)) {
      const __nav: { [key: string]: string } = {};
      __nav[MY_LOAD] = getPath();
      dispatch(setNavigation(__nav));
      history.push(__nav[MY_LOAD], {
        direction: 'none'
      });
    }    
  },[navString, selectedTab, history.location.pathname, props.myLoadCount]);

  useEffect(() => {
    const {carrierTenderedCount, carrierAssignedCount, ...driverMyLoadCount} = props.myLoadCount;
    let isMyLoadCountUpdated = !!Object.values(isDispatcherRole()?props.myLoadCount:driverMyLoadCount).find((item : any) =>item != 0);
    if (selectedTab === MY_LOAD && isMyLoadCountUpdated && !(history.location?.state?.shipmentId)) {
      const __nav: { [key: string]: string } = {};
      const path = getPath();
      const url = path !== history.location.pathname && history.location.pathname.includes("CarrierTendered") ? path : history.location.pathname;
      __nav[MY_LOAD] = url;
      dispatch(setNavigation(__nav));
      history.push(__nav[MY_LOAD], {
        direction: 'none',
        location: {
          pathname: __nav[MY_LOAD]
        }
      });      
    }
  }, [selectedTab]);

  useEffect(() => {
    setTileNavigation(props.navigation);
  }, [navString]);

  useEffect(() => {
    setSidebarRoutes(sideBarTabs(isDispatcherRole()))
  }, [isDispatcherRole()]);

  useEffect(() => {
    const presentRoute = sideBarTabs(isDispatcherRole()).find(
      (item) => history.location.pathname === item.path
    );
    const pathname =
      (history && history.location && history.location.pathname) || "";
    const isMyload =
      pathname === "/app/MyLoad/DriverAssigned" ||
      pathname === "/app/myLoad/DriverAssigned" ||
      pathname === "/app/MyLoad/InTransit" ||
      pathname === "/app/MyLoad/DeliveredNeedsPPWK" ||
      pathname === "/app/MyLoad/DeliveredWithPPWK" ||
      pathname === CARRIER_ASSIGNED_MODULE_WEB ||
      pathname === CARRIER_TENDERED_MODULE_WEB ||
      pathname.includes("/app/myLoad/Execution/") ||
      pathname.includes("/app/MyLoad/") ||
      pathname.includes("/app/myLoad/");

    if (presentRoute || isMyload) {
      if (isMyload) {
        onSelectTab("myLoad");
        onSelectMoreTab("");
      } else {
        onSelectTab(presentRoute ? presentRoute.slug : "myLoad");
        onSelectMoreTab("");
      }
    } else if (
      pathname === "/app/manage-capacity/add" ||
      pathname == "/app/manage-capacity" ||
      pathname == "/app/manage-capacity/see-results" ||
      pathname.includes("/app/manage-capacity/view/") ||
      pathname.includes("/app/manage-capacity/edit/")
    ) {
      onSelectTab("manage");
      onSelectMoreTab("");
    }
    else if (
      pathname === "/app/feedback" ||
      pathname.includes("/app/feedback") 
    ) {
      onSelectTab("moretab")
      onSelectMoreTab("feedback")
    }
    else if (
      pathname == "/app/preferences" ||
      pathname.includes("/app/preferences")
    ) {
      onSelectTab("moretab")
      onSelectMoreTab("preferences")
    }
    else if (
      pathname == "/app/support" ||
      pathname.includes("/app/support")
    ) {
      onSelectTab("moretab")
      onSelectMoreTab("more")
    } else {
      onSelectTab("");
      onSelectMoreTab("");
    }
  }, [history.location.pathname]);

  useEffect(() => {
    if (contentStackData) {
      const notificationData =
        contentStackData.data?.getWebContent?.homeBanner?.entries[0];
      setContentStackObj(notificationData);
      if (
        notificationData &&
        (notificationData.title ||
          notificationData.description ||
          notificationData.linkTitle)
      ) {
        SetShowNotification(true);
      }
    }
  }, [contentStackData]);

  const handleModalToggle = () =>{   
      setOpenMoreModal(!openMoreModal);
  };

  const handleModalClose = () =>{
    setOpenMoreModal(false);
  };

  const doScroll = (target: any) => {
    document
      .getElementsByClassName("sni-body-container")[0]
      .scrollTo(0, target);
  };

  const isGuest = () => {
    return (
      IONICWrapper.details.auth.user.roles.length === 1 &&
      IONICWrapper.details.auth.user.roles[0] === USER_ROLES.carrierGuest
    );
  };

  const getHref = (route: any) => {
    // handling acess for manageCapacity and myLoads for Guest
    if ((route.slug === "myLoad" || route.slug === "manage" || route.slug === HOME ) && isGuest()) {
      ToastMessage.show(REGISTER_TO_GET_FULL_ACCESS);
      return;
    }
    if (route.slug == "myLoad" && !isEntitled("myLoad", "carrierTendered")) {
      return getPath();
    } else if (route.slug == MY_LOAD) {
      let nav: { [key: string]: string } = Object.create(sidebarNav || {});
      if (nav[MY_LOAD]) {
        route.path = (nav[MY_LOAD]).includes("Execution") ? getPath(): nav[MY_LOAD];
      }
      return route.path;
    } else if (route.slug === PREFERENCES) {
      // handling access for FEEDBACK, PREFERENCES, SUPPORT
      if (isEntitled("manage", "carrierProfile")) {
        return route.path;
      } else {
        ToastMessage.show(REGISTER_TO_GET_FULL_ACCESS);
        return;
      }
    }

    // access to home, feedback, more is available to every kind of role for web
    if (route.slug === HOME || route.slug === FEEDBACK || route.slug === MORE) {
      return route.path;
    }
    if (route.slug === "manage" && isEntitled(route.slug, "manageMyCapacity")) {
      return route.path;
    }
    if (route.slug === "search" && isEntitled(route.slug, "newSearch")) {
      return route.path;
    }
    if (route.slug === "my_drivers" && isEntitled("manage", "manageUsersWeb")) {      
      return route.path;
    }
    ToastMessage.show(REGISTER_TO_GET_FULL_ACCESS);
    return noAccessUrl;
  };

  const getPath = () => {
    let URL 
    if(isDispatcherRole() && props.myLoadCount && props.myLoadCount.carrierTenderedCount > 0) {
      URL = CARRIER_TENDERED_MODULE_WEB;
    } else if(
      isDispatcherRole() && props.myLoadCount && props.myLoadCount.carrierAssignedCount > 0
    ) {
      URL = CARRIER_ASSIGNED_MODULE_WEB;
    } else if (
      props.myLoadCount && props.myLoadCount.driverAssignedCount > 0
    ) {
      URL = DRIVER_ASSIGNED_MODULE_WEB;
    } else if (props.myLoadCount && props.myLoadCount.inTransitCount > 0) {
      URL = INTRANSIT_MODULE_WEB;
    } else if (props.myLoadCount && props.myLoadCount.deliveredNeedsPaperWorkCount > 0) {
      URL = DELIVERED_NEEDS_PPWK_MODULE_WEB;
    } else if (
      props.myLoadCount && props.myLoadCount.deliveredWithPaperWorkCount > 0
    ) {
      URL = DELIVERED_WITH_PPWK_MODULE_WEB;
    } 
    else if(isDispatcherRole()) {
      URL = CARRIER_TENDERED_MODULE_WEB; 
    } else URL = DRIVER_ASSIGNED_MODULE_WEB;
    return URL;
  };
  
  const navCheck = (tab: any) => {
    let route: any;
    if (tab === MY_LOAD) {
      const nav: { [key: string]: string } = sidebarNav || {};
      if (!nav[MY_LOAD]) {
        const __nav: { [key: string]: string } = {};
        __nav[MY_LOAD] = getPath();
        dispatch(setNavigation(__nav));
      }
    }
    if(tab === "moretab" || tab === "preferences" || tab === "feedback" || tab === "more")
    {
       const moreRoutes = sidebarRoutes && sidebarRoutes.filter((route :IRoute) =>{
          return route.subCategory|| null })
       route = moreRoutes && moreRoutes[0].subCategory && moreRoutes[0].subCategory.find((route: IRoute) => tab === route.slug) || null;
    }
    else if (tab == "my_drivers") {
      logEvent(EVENT.UE_MY_DRIVERS, {
        screen: SCREEN.WEB_LEFT_NAV_RIBBON,
        lead: "letf-nav",
        user_role: IONICWrapper.details.auth.user.roles,
        sessionId: IONICWrapper.details.auth.sessionId,
      });
      route = sidebarRoutes.find((route: IRoute) => tab === route.slug) || null;
      getHref({ slug: tab, path: route ? route.path : '' });
    } 
    else {
      route = sidebarRoutes.find((route: IRoute) => tab === route.slug) || null;
    }

    if (tab === 'fuel_saving') {
      const fuelSavingRedirectionLink =
        (IONICWrapper.details.keys?.configuration?.fuelSaving?.redirectionLink) ||
        FUEL_SAVING.redirectionLink;
      handleModalClose();
      window && window.open(fuelSavingRedirectionLink, '_blank');
      logEvent(EVENT.UE_FUEL_SAVINGS_REDIRECTION, {
        screen: SCREEN.WEB_LEFT_NAV_RIBBON
      });
    } else if (tab === 'trailer_lease') {
      const _TRAILER_LEASE_MODAL = TRAILER_LEASE_MODAL;
      logEvent(EVENT.UE_TRAILER_LEASE, {
        screen: SCREEN.WEB_LEFT_NAV_RIBBON
      });
      handleModalClose();
      const TrailerLeaseModalProps = {
        isModalOpen: true,
        aditionalCssClass : "trailer_lease",
        title:IONICWrapper.details.getKeyValuePairs("trailer_lease_title") || _TRAILER_LEASE_MODAL.trailer_lease_title,
        message_content:IONICWrapper.details.getKeyValuePairs("trailer_lease_message") || _TRAILER_LEASE_MODAL.trailer_lease_message,
        size: "extra_small_height",
        contentScroll: "deny",
        buttons: [
          {
            title: IONICWrapper.details.getKeyValuePairs("trailer_lease_cancel_button_title") || _TRAILER_LEASE_MODAL.trailer_lease_cancel_button_title,
            type: "secondary-cta-btn-web",
            onClick: () => {
              setModalProps({
                isModalOpen:false
              })
            }
          },
          {
            title: IONICWrapper.details.getKeyValuePairs("trailer_lease_ok_button_title") || _TRAILER_LEASE_MODAL.trailer_lease_ok_button_title,
            type: "primary-cta-btn-web",
            onClick: () => {
              window && window.open(IONICWrapper.details.getKeyValuePairs("trailer_lease_redirection_url") || _TRAILER_LEASE_MODAL.trailer_lease_redirection_url, '_blank');
              logEvent(EVENT.UE_TRAILER_LEASE_REDIRECTION, {
                screen: SCREEN.WEB_LEFT_NAV_RIBBON
              });
              setModalProps({
                isModalOpen:false
              })
            }
          }
          
        ]
      };
      setModalProps({...TrailerLeaseModalProps})
    } 
    else {
      const _subcategory = sideBarTabs(isDispatcherRole())?.find((item: IRoute) => item?.slug === tab)?.subCategory;
      if (_subcategory) {
        setSubcategoryProps({
          isModalOpen: true,
          aditionalCssClass: "sidebar-subcategory",
          size: "subcategory_dimention",
          contentScroll: "deny",
          backdropDismiss: true,
          subcategory: [..._subcategory]
        })
        handleModalToggle();       
      } else {
        handleModalClose();
        if(tab === "manage" && !location?.pathname?.toLowerCase()?.includes(tab)){
          dispatch(setManageSegmentSelected("ALL"));
        }
        history.push(getHref({ slug: tab, path: route ? route.path : '' }), {
          direction: 'none'
        });
      }
    }
  };

  const compatibleWidth = IONICWrapper.details.keys?.configuration.compatibleWidth ||
    COMPATIBILE_WIDTH;
  const resolutionIncompatibleMessage = IONICWrapper.details.keys?.configuration.resolutionIncompatibleMessage ||
    RESOLUTION_INCOMPATIBLE_MESSAGE;
  const resolutionIncompatibleMessageObj = {
    title: resolutionIncompatibleMessage
  };

  const handleResize = () => {
    setShowModal((!isPlatform("mobile") && window.innerWidth < compatibleWidth) ? true : false);
  };

  const handleTabSelect = (e: any) => {
    navCheck(e.detail.tab);
    (e.detail.tab === 'fuel_saving' || e.detail.tab === "trailer_lease") &&  onSelectTab(selectedTab);
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <React.Fragment>
      <div
        className={`sni-body-wrapper ${showNotification || showModal ? (showNotification && showModal) ? "notification_compatibility_banner" : "notification" : ""}`}
      >
        {showNotification ? (
          <Notification
            close={SetShowNotification}
            contentStackData={contentStackobj}
          />
        ) : null}
        {showModal ? (
          <Notification
            close={setShowModal}
            contentStackData={resolutionIncompatibleMessageObj}
          />
        ) : null}
        <IonTabs
          data-testid="navCheck"
          onIonTabsWillChange={(e: any) => {
            navCheck(e.detail.tab);
            (e.detail.tab === 'fuel_saving' || e.detail.tab === "trailer_lease") &&  onSelectTab(selectedTab);
          }}>
          <IonRouterOutlet className="sni-body-container" animated={false}>
          <Switch>
            <Route
              path="/app/home"
              render={(props: any) => (
                <AuthWrapper
                  Component={DashoardContainer}
                  props={{
                    ...props
                  }}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/search"
              render={(props: any) => (
                <AuthWrapper
                  Component={SearchContainer}
                  props={{
                    ...props,
                    doScroll,
                  }}
                />
              )}
              exact
            />
            <Route
              path="/app/stof"
              render={(props: any) => (
                <AuthWrapper Component={SearchResultContainer} props={props} />
              )}
              exact={true}
            />
            <Route
              path="/app/search/results"
              render={(props: any) => (
                <AuthWrapper Component={SearchResultContainer} props={props} />
              )}
              exact
            />
              <Route
              path="/app/myLoad/CarrierTendered"
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: CarrierTenderedContainer }}
                />
              )}
              exact
            />
            <Route
              path={CARRIER_ASSIGNED_MODULE_WEB}
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: CarrierAssignedContainer }}
                />
              )}
              exact
            />
            <Route
              path="/app/myLoad/DriverAssigned"
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: DriverAssignedContainer }}
                />
              )}
              exact
            />
            <Route
              path="/app/myLoad/InTransit"
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: InTransitContainer }}
                />
              )}
              exact
            />
            <Route
              path="/app/myLoad/DeliveredNeedsPPWK"
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: RecentlyDeliverdContainer }}
                />
              )}
              exact
            />
              <Route
              path="/app/myLoad/DeliveredWithPPWK"
              render={(props: any) => (
                <AuthWrapper
                  Component={MyLoadsContainer}
                  props={{ ...props, Component: DeliveredWithPPWKContainer }}
                />
              )}
              exact
            />
            <Route
              path="/app/myLoad/Execution/:id"
              render={(props: any) => (
                <AuthWrapper
                  Component={ExecutionContainer}
                  props={{ ...props, Component: ExecutionDetailsContainer }}
                />
              )}
              exact
            />
            <Route
              path="/app/myLoad"
              render={() => <Redirect to={isDispatcherRole() ? CARRIER_TENDERED_MODULE_WEB : DRIVER_ASSIGNED_MODULE_WEB} />}
              exact
            />
            <Route
              path="/app/userProfile/edit"
              render={(props: any) => (
                <AuthWrapper Component={ManageProfileContainer} props={props} />
              )}
              exact
            />
            {(isEntitled("manage", "manageUsersWeb")) && (
              <Route
                path="/app/manage/ManageUser"
                render={(props: any) => (
                  <AuthWrapper Component={ManageUserContainer} props={props} />
                )}
                exact
              />
            )}
            {(isEntitled("myLoad", "addUser") ||
              isEntitled("manage", "manageUsersWeb")) && (
              <Route
                path="/app/userProfile/add"
                render={(props: any) => (
                  <AuthWrapper
                    Component={ManageProfileContainer}
                    props={props}
                  />
                )}
                exact
              />
            )}
            {isEntitled("manage", "carrierProfile") && (
              <Route
                path="/app/companyProfile"
                render={(props: any) => (
                  <AuthWrapper
                    Component={CarrierProfileContainer}
                    props={props}
                  />
                )}
                exact
              />
            )}
            <Route
              path="/app/notifications"
              render={(props: any) => (
                <AuthWrapper Component={NotificationContainer} props={props} />
              )}
              exact
            />
            <Route
              path="/app/userProfile"
              render={(props: any) => (
                <AuthWrapper Component={ProfileContainer} props={props} />
              )}
              exact
            />
            <Route
              path="/app/manage-capacity"
              render={(props: any) => (
                <AuthWrapper
                  Component={ManageCapacityContainer}
                  props={props}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/manage-capacity/see-results"
              render={(props: any) => (
                <AuthWrapper
                  Component={ManageCapacitySeeResultContainer}
                  props={props}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/manage-capacity/add"
              render={(props: any) => (
                <AuthWrapper
                  Component={ManageCapacityAddContainer}
                  props={props}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/manage-capacity/view/:id"
              render={(props: any) => (
                <AuthWrapper
                  Component={ManageCapacityViewContainer}
                  props={props}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/manage-capacity/edit/:id"
              render={(props: any) => (
                <AuthWrapper
                  Component={ManageCapacityEditContainer}
                  props={props}
                />
              )}
              exact={true}
            />
            <Route
              path="/app/support"
              render={(props: any) => <SupportContainer {...props} />}
              exact={true}
            />
            <Route
              path="/app/feedback"
              render={(props: any) => (
                <AuthWrapper Component={FeedbackContainer} props={props} />
              )}
              exact
            />
            <Route
              path="/app/preferences"
              render={(props: any) => (
                <AuthWrapper Component={PreferencesContainer} props={props} />
              )}
              exact
            />
            <Redirect from="/app/manageUsers" to="/app/manage/ManageUser" />
          </Switch>
          </IonRouterOutlet>
          <IonTabBar slot="bottom">{
              sidebarRoutes?.map((route: IRoute, index: number) => {
              if (isEntitled("sidebar", route?.visibilityKey)) {
                return <IonTabButton
                  key={`sidebar_${index}`}
                  tab={route.slug}
                  className={`${route.slug}_button ${selectedTab == route.slug && 'tab-selected'}`}>
                  <IonIcon
                    src={`assets/icon/${route.icon}`}
                    class={`${route.slug === 'manage' ? `desktop_${route.slug}` : route.slug
                      }_icon`}></IonIcon>
                  <IonLabel class="tab-menu-label">{route.label}</IonLabel>
                </IonTabButton>
              }
            })}
          </IonTabBar>
        </IonTabs>
        <BackToTop scrollBehaviour={EBehaviour.Instant} isVisible={isMyload((history && history.location && history.location.pathname))}/>
        <CustomModalWeb {...modalProps} />
        {openMoreModal &&
          <div className='sidebar-subcategory'
          onMouseLeave={()=>{handleModalClose()}}
          >
            {subcategoryProps?.subcategory?.map((item: IRoute, index: number) => {
              return <IonTabButton
                key={`sidebar_${index}`}
                tab={item.slug}
                data-testid='navCheck'
                className={`${item.slug}_button ${(selectedTab == item.slug || selectedMoreTab == item.slug) && 'tab-selected'}`}
                onClick={(e: any) => { navCheck(e.detail.tab); }}
              >
                <IonIcon
                  src={`assets/icon/${item.icon}`}
                  class={`${item.slug === 'manage' ? `desktop_${item.slug}` : item.slug
                    }_icon`}></IonIcon>
                <IonLabel class="tab-menu-label">{item.label}</IonLabel>
              </IonTabButton>
            })
            }
          </div>
        }
      </div>
    </React.Fragment>
  );
};

interface AuthProps {
  Component: any;
  props: any;
}
/**
 * method to check if session is active or not. if not user will be redirected to landing screen.
 * @param {Component} Component routing Component.
 * @param {Object} props routing component properties.
 * @returns {Component} returns wrapped component.
 */
export const AuthWrapper: React.FC<AuthProps> = React.memo(
  ({ Component, props }) => {
    const [validSession, setValidSession] = useState(false);
    useEffect(() => {
      setValidSession(true);
    }, []);
    useAuthService().hasSession(validSession, setValidSession);
    return <Component {...props} />;
  }
);

export default Sidebar;
